import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { AlertPopupComponent } from '../shared/popups/alert-popup/alert-popup.component';
import { Configuration } from '../config/config';
import { HttpClient } from '@angular/common/http';
declare var navigator;
@Injectable()
export class HttpErrorService {

  private errors = new BehaviorSubject<string[]>([]);
  modalRef;
  isModalOpen = false;
  constructor(private _ngbModal: NgbModal, private http:HttpClient) {

  }

  showError(errors: string) {
    if(!this.isModalOpen){
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.modalRef = this._ngbModal.open(AlertPopupComponent);
      this.modalRef.componentInstance.errorMessage = errors;
      let details = {
        userName: currentUser && currentUser.user && currentUser.user.username ? currentUser.user.username: currentUser,
        speed: navigator.connection.downlink,
        error: errors
      }
      this.saveUsersGameFailedToLoadResources(details).subscribe(res => {})
    }
    this.modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.isModalOpen = true;
    });
    this.modalRef.componentInstance.changeFlag.subscribe((receivedEntry) => {
      this.isModalOpen = false;
    });
  }

  saveUsersGameFailedToLoadResources(details){
    return this.http.post(Configuration.ServerWithApiUrl+'/saveUsersGameFailedToLoadResources',details)
      .map((res: any)=>res)
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/http-error.service.ts